import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Button, Dialog, DialogContent, IconButton, TextField } from '@mui/material';
import React, { Component, useEffect, useRef, useState } from "react";
import axios from 'axios';
import { ProjectConfig } from 'Global';
import { createGeneralRomanCalendar } from '../../liturgy/romcal';

import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Link, useNavigate } from 'react-router-dom';
import { getCalendarioLiturgicoLabel } from 'hooks/useLabels';
/*========================================
GET TODAY DATE
========================================*/
const today: any = new Date();
//temp 30 dic 2025
// const today: any = new Date(2025, 11, 30);
const todayFormated = [
  today.getFullYear(),
  String(today.getMonth() + 1).padStart(2, '0'),
  String(today.getDate()).padStart(2, '0')
].join('-');


/*========================================
CHECK IF calendarBarInfo IS IN LOCAL STORAGE
========================================*/
let flag = false;
//check if calendarBarInfo exists in local storage
if (localStorage.getItem("calendarBarInfo")) {
  const romcal_data = JSON.parse(localStorage.getItem("calendarBarInfo") || "");
  //check id romcal_data.today is different from today
  if (romcal_data.today != todayFormated) {
    flag = true;
  }
}
else {
  flag = true;
}
/*========================================
========================================*/



export default function CalendarBar(props: { setFechaView: (fecha: string) => void }) {

  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);
  const touchStartX = useRef<number | null>(null);
  const [calendarInfo, setCalendarInfo] = useState<any>([]);
  const [currentLangName, setCurrentLangName] = useState<string>('');



  useEffect(() => {
    const currentLangId = localStorage.getItem('lang_id') || '1';

    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'lang_list'
      }
    })
    .then((response) => {
      const langs = response.data?.lang_list || [];
      const currentLang = langs.find((item: any) => String(item.lang_id) === String(currentLangId));
      setCurrentLangName(currentLang?.lang || '');
    })
    .catch((err) => {
      console.log('Error loading current language:', err?.data || err);
      setCurrentLangName('');
    });

    // Verificar si la fecha guardada es anterior a hoy
    const savedDate = localStorage.getItem('date');
    if (savedDate) {
      const savedDateObj = new Date(savedDate);
      const todayDateObj = new Date(todayFormated);
      
      // Si la fecha guardada es anterior a hoy, resetear a hoy
      if (savedDateObj < todayDateObj) {
        localStorage.setItem('date', todayFormated);
        props.setFechaView(todayFormated);
      }
    }

    //if flag is true, get romcal data
    if (flag) {
      getRomcalData()
    }


  }, []);

  const getRomcalData = () => {

    /*========================================
    GET YEAR
    ========================================*/
    const year = todayFormated.split("-")[0];

    /*========================================
    ROMCAL DATA
    ========================================*/
    let romcalArray: any = [];
    const romcal = createGeneralRomanCalendar();
    romcal.generateCalendar(year).then((data) => {

      //GET NEXT 7 VALID DAYS (saltando los que no tengan datos)
      const next7Days = [];
      let daysFound = 0;
      let dayOffset = 0;
      const maxAttempts = 30; // Evitar loop infinito

      while (daysFound < 7 && dayOffset < maxAttempts) {
        const nextDay = new Date(today);
        nextDay.setDate(nextDay.getDate() + dayOffset);
        
        //NEXT DAY FORMATED TO YYYY-MM-DD DAY WITH 0
        const day = ("0" + nextDay.getDate()).slice(-2);
        const month = ("0" + (nextDay.getMonth() + 1)).slice(-2);
        const nextDayFormated = nextDay.getFullYear() + "-" + month + "-" + day;

        // Verificar que data[nextDayFormated] existe y tiene elementos
        if (data[nextDayFormated] && data[nextDayFormated][0]) {
          next7Days.push(nextDayFormated);
          daysFound++;
        } else {
          console.warn(`No romcal data for day: ${nextDayFormated}, skipping...`);
        }
        
        dayOffset++;
      }

      // console.log('next7Days');
      // console.log(next7Days);

      //GET ROMCAL DATA FOR NEXT 7 DAYS
      next7Days.forEach((day) => {

        const colors = data[day][0].colors;
        const date = data[day][0].date;
        const dayOfWeek = data[day][0].calendar.dayOfWeek;
        const weekOfSeason = data[day][0].calendar.weekOfSeason;
        const seasons = data[day][0].seasons;
        const rank = data[day][0].rank;

        const romcalData = {
          id: data[day][0].id,
          name: data[day][0].name,
          colors: colors,
          date: date,
          dayOfWeek: dayOfWeek,
          weekOfSeason: weekOfSeason,
          seasons: seasons,
          rank: rank,
          precedence: data[day][0].precedence,
          commonsDef: data[day][0].commonsDef,
          fromCalendarId: data[day][0].fromCalendarId
        }

        romcalArray.push(romcalData);
      })

      console.log("rm", romcalArray);

      /*========================================
      API
      ========================================*/
      const lang_id = localStorage.getItem('lang_id') || '1';
      axios.get(ProjectConfig.api_url,
        {
          params: {
            request: 'calendar_bar_info',
            romcalArray: JSON.stringify(romcalArray),
            lang_id: lang_id
          }
        })
        .then((response) => {
          console.log("response", response.data);
          setCalendarInfo(response.data);

        })
        .catch((err) => {
          console.log(err.data);
        })


      const calendarBarInfo = {
        today: todayFormated,
        romcalData: romcalArray
      }

      //SET ROMCAL DATA IN STATE
      //setRomcalData(romcalArray);
      //localStorage.setItem("calendarBarInfo", JSON.stringify(calendarBarInfo));

    });
    /*========================================
    ========================================*/


  }

  const data = [
    {
      weekName: "Semana 24 Tiempo de adviento",
      maxima: "",


    }
  ]

  const selectSlide = (newIndex: number) => {
    if (!calendarInfo || calendarInfo.length === 0) return;

    const normalizedIndex = (newIndex + calendarInfo.length) % calendarInfo.length;
    const newDate = calendarInfo[normalizedIndex]?.date;
    if (!newDate) return;

    setActiveSlide(normalizedIndex);
    props.setFechaView(newDate);
    localStorage.setItem('date', newDate);
  };

  const prevSlide = () => selectSlide(activeSlide - 1);

  const nextSlide = () => selectSlide(activeSlide + 1);

  const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
    touchStartX.current = event.touches[0]?.clientX ?? null;
  };

  const handleTouchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
    if (touchStartX.current === null) return;

    const endX = event.changedTouches[0]?.clientX ?? touchStartX.current;
    const deltaX = endX - touchStartX.current;
    touchStartX.current = null;

    if (Math.abs(deltaX) < 45) return;
    if (deltaX < 0) nextSlide();
    else prevSlide();
  };

  const [date, setDate] = useState(todayFormated);
  const [openDialog, setOpenDialog] = useState(false);

  const handleDateChange = (newDate: any) => {
    navigate("/calendario/" + newDate);
    setOpenDialog(false);
  }

  // Función para construir texto del día traducido
  const getTextoDia = (item: any) => {
    if (!item) return '';
    const dayName = getCalendarioLiturgicoLabel(item.dayOfWeekKey || 'domingo').toUpperCase();
    const dayNumber = item.dayNumber || '';
    const monthName = getCalendarioLiturgicoLabel(item.monthKey || 'enero').toUpperCase();
    const de = getCalendarioLiturgicoLabel('de').toUpperCase();
    return `${dayName}, ${dayNumber} ${de} ${monthName}`;
  };

  // Función para construir nombre de semana traducido
  const getWeekName = (item: any) => {
    if (!item) return '';
    const semana = getCalendarioLiturgicoLabel('semana').toUpperCase();
    const weekNum = item.weekOfSeason || '';
    const de = getCalendarioLiturgicoLabel('de').toUpperCase();
    const seasonName = getCalendarioLiturgicoLabel(item.seasonsKey || 'tiempo_ordinario').toUpperCase();
    return `${semana} ${weekNum} ${de} ${seasonName}`;
  };

  // Función para construir fecha corta traducida (para el bottom)
  const getDateFormatted = (item: any) => {
    if (!item) return '';
    const dayNumber = item.dayNumber || '';
    const de = getCalendarioLiturgicoLabel('de');
    const monthName = getCalendarioLiturgicoLabel(item.monthKey || 'enero');
    return `${dayNumber} ${de} ${monthName}`;
  };

  const activeItem = calendarInfo[activeSlide];

  return (
    <div id="CalendarBar">
      {activeItem && (
        <div
          id="CalendarbarTop"
          className={activeItem.cssClass}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <Link to={"/calendario/" + activeItem.date}>
            <h2 className={activeItem.cssClass}>{getTextoDia(activeItem)}</h2>
            <h2 className={activeItem.cssClass}>{getWeekName(activeItem)}</h2>
            {activeItem.santo && (
              <h2 className={activeItem.cssClass}>{activeItem.santo} {activeItem.propio === "0" ? <span></span> : <> - {getCalendarioLiturgicoLabel('fiesta_propia').toUpperCase()} </>}</h2>
            )}
            <p>{activeItem.maxima}</p>
          </Link>
        </div>
      )}
      <div id="CalendarbarBottom" className={activeItem?.cssClass}>
        <div id="CalendarbarBottomLeft">
          <IconButton size="small" aria-label="back" sx={{ color: "#fff" }} onClick={prevSlide}>
            <ArrowBackIosNewIcon />
          </IconButton>

          <IconButton size="small" aria-label="back" sx={{ color: "#fff" }} onClick={() => { setOpenDialog(true) }}>
            <CalendarMonthIcon />
          </IconButton>

          <IconButton size="small" aria-label="back" sx={{ color: "#fff" }} onClick={nextSlide}>
            <ArrowForwardIosIcon />
          </IconButton>
        </div>

        {currentLangName && (
          <Button
            id="CalendarbarLanguageLabel"
            component={Link}
            to="/cuenta"
            size="small"
            sx={{ textTransform: "none" }}
          >
            {currentLangName}
          </Button>
        )}

        <Button
          id="CalendarbarTodayButton"
          size="small"
          component={Link}
          to={"/calendario/" + todayFormated}
          sx={{ textTransform: "none", fontSize: "1rem", color: "#000", backgroundColor: "#00000050", borderRadius: "0" }}

        >
          {getCalendarioLiturgicoLabel('hoy')}
        </Button>
        <div id="CalendarbarBottomRight" className={activeItem?.cssClass}>

          <Link to={"/calendario/" + activeItem?.date}>
            {getDateFormatted(activeItem)}
          </Link>
        </div>
      </div>


      <Dialog open={openDialog} onClose={() => { setOpenDialog(false) }}>
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <StaticDatePicker className='filters_datePicker'
              label="Fecha"
              displayStaticWrapperAs="mobile"
              value={date}
              showToolbar={false}

              onChange={(newValue: any) => {
                newValue && handleDateChange(newValue.format('YYYY-MM-DD'));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </DialogContent>
      </Dialog>


    </div>
  );
}



